import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ConfigService } from '../services/config.service';
import { SearchService } from '../search/services/search.service';

@Injectable({
  providedIn: 'root'
})
export class MetadataService {

	constructor(
		private searchService: SearchService,
		private configService: ConfigService,
		private http: HttpClient
	) { }
	
	async getTemplate(): Promise<any> {
		let url = this.configService.getMetadataCustomTemplateURL();
		if (!url) {
			return Promise.resolve({});
		}

		try {
			return await firstValueFrom(this.http.get<any>(url, {}));
		} catch (error) {
			return Promise.reject(error);
		}
	}
	
	/**
	 * Utility function to determine if a value is a valid collection value.
	 */	
	isValidFieldCollectionValue(field: string, value: string): boolean {
		return this.searchService.isValidCollectionValue(field, value);
	}	

	/**
	 * Utility function to clean a value by removing <mark> and </mark> tags.
	 */
	cleanValue(value: string): string {
		if (value == null || value === "") {
			return "&nbsp;";
		}
		
		let cleanedValue = this.strReplaceAll(value, '<mark>', '');
		cleanedValue = this.strReplaceAll(cleanedValue, '</mark>', '');
		return cleanedValue;
	}
	
	private strReplaceAll(value: string, search: string, replacement: string): string {
		if (typeof value !== "string") {
			return value;
		}
		return value.split(search).join(replacement);
	}
	
	/**
	 * Utility function to format a list of links from a string.
	 */
	linksFromString(linkString: string, fieldName?: string): { name: string, href: string }[] {
		if (linkString == null || linkString === "") {
			return [];
		}
		
		let links = linkString.split(";");
		let processedLinks = [];
		for (let idx = 0; idx < links.length; idx++) {
			if (links[idx].indexOf('||') > -1) {
				let pairs = links[idx].split('||');
				if (pairs.length == 2) {
					processedLinks.push({ "name": pairs[0], "href": pairs[1] });
				} else {
					processedLinks.push({ "name": links[idx], "href": links[idx] });
				}
			} else {
				processedLinks.push({ "name": this.getBrowseLinkDisplayString(links[idx], fieldName), "href": links[idx] });
			}
		}
		return processedLinks;
	}
	
	getBrowseLinkDisplayString(linkString: string, fieldName?: string): string {
		if(fieldName && 'browsepath' === fieldName){
			let displayName = '';
			let links = linkString.split('>>');
			let sep = '';
			for (let idx = 0; idx < links.length; idx++) {
				let pairs = links[idx].split(':');
				if (pairs.length == 2) {
					displayName+=sep+pairs[1];
					sep = '>>';
				} else {
					console.log('Failed to parse browse path ' + linkString);
					return linkString;
				}
			}
			return displayName;
			
		}
		return linkString;
	}
	
	/**
	 * Opens a new window with the formatted metadata.
	 */
	printMetadata(data: string, title: string): void {
		let strings = data.split("<br>");
		data = "";
		strings.forEach((string: string) => {
			data += "<div>" + string + "</div>"
		});

		let windowContent = '<!DOCTYPE html>';
		windowContent += '<html>';
		windowContent += '<head><title>' + title + '</title>';
		windowContent += '<script type="text/javascript">\n';
		windowContent += '<!-- \n';
		windowContent += 'function doPrint(){ window.print(); } \n';
		windowContent += '//--></script>';
		windowContent += '</head>';
		windowContent += '<style>';
		windowContent += 'div {';
		windowContent += 'white-space: pre-wrap !important;';
		windowContent += '}';
		windowContent += '</style>';
		windowContent += '<body>';
		windowContent += '<div><a href="javascript:window.print();">Print</a></div>';
		windowContent += '<div><pre>' + data + '</pre></div>';
		windowContent += '</body>';
		windowContent += '</html>';

		let printWin: Window | null = window.open();

		if (printWin) {
			printWin.document.open("text/html", "replace");
			printWin.document.write(windowContent);
			printWin.document.close();
		} else {
			console.error('Failed to open a new window. Check your popup blocker settings.');
		}
	}
}
